class Analytics {
  constructor(implementations) {
    this.implementations = implementations;

    window.addEventListener("error", ev => {
      this.exception({
        description: `[${window.location.pathname}]:[${ev.error}]`,
        fatal: true,
      });
    });
  }

  initialize = () => {
    this.implementations.forEach(implementation => implementation.initialize());
  };

  pageView = path => {
    this.implementations.forEach(implementation => implementation.pageView(path));
  };

  /**
   * @param {Object} data - description {string} and fatal {bool} properties of the error
   */
  exception = data => {
    this.implementations.forEach(implementation => implementation.exception(data));
  };

  /**
   * @typedef {object} EventData
   * @property {string} category
   * @property {string} action
   * @property {string} label
   * @property {int} value
   */

  /**
   * @param {EventData} data
   */
  event = data => {
    this.implementations.forEach(implementation => implementation.event(data));
  };
}

export default Analytics;
